import { render } from "./ListAssignedDocuProj.vue?vue&type=template&id=1fef239c"
import script from "./ListAssignedDocuProj.vue?vue&type=script&lang=js"
export * from "./ListAssignedDocuProj.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__